export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const SET_SELECTED_OPTION_WITH_MDV = 'SET_SELECTED_OPTION_WITH_MDV';

export const MOBILE_DRAWER_ID = 'volumeDiscountDrawerID';
